import React, { PureComponent, Fragment } from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import {
  Select,
  Tooltip,
  message,
  Switch,
  Input,
  Checkbox,
  Spin,
  Button,
  Radio,
  Collapse,
  InputNumber,
  Tag,
  Alert
} from 'antd';
import { ROCKY, SIERRA } from '../../constants/pageType';
import TreeSelectComp from '@/components/TreeSelect';
import { strDelimited } from '@/services/helper/split';
import { getTableAmiParameters, getTableAmiParametersValue, amiParameterValueCheck, ibisAMIModelParamsParse, generateRangeArray } from '@/services/Rocky/AMIModelHelper/amiParameterHelper';
import EditableTable from '@/components/EditableTable';
import { BOOLEAN, LIST, CORNER, RANGE, STRING, INTEGER, FLOAT, TAP, GAUSSIAN, PARAMETER_DUAL_DIRAC, PARAMETER_DJRJ } from '@/services/Rocky/AMIModelHelper/constants';
import TagsInput from '../TagsInput';
import JittersTable from './ADSComp/jitterTable';
import { checkRemoveDcOffsetChange } from "../../services/Rocky/AMIModelHelper/amiParameterHelper";
import { IBIS_ODT, CUSTOM_ODT, IBIS_AMI_FILE_MODEL, AMI_OBJ_PARAM } from '../../services/Rocky/AMIModelHelper/constants';
import { getAMIDiffData, getIBISDiffData, getMultipleDisable } from '../../services/Rocky/sweep/sweepingHelper';
import { IO } from '../../services/LibraryHelper';
import { ADS, HSPICE } from '../../constants/resolution';
import { checkODT } from '../../services/Rocky/AMIModelHelper/amiParameterHelper';
import './index.css';

const IBIS = 'IBIS', IBIS_AMI = "IBIS_AMI"/* , IBIS_AMI_LIST = [IBIS, IBIS_AMI] */;
const OUTPUT = ['Output', 'Open_drain', 'Open_sink', 'Open_source'];
const RadioGroup = Radio.Group;
const DELAY_RISING = 'delayRise', DELAY_FALLING = 'delayFall', TAILS_RISING = 'tailsRise', TAILS_FALLING = 'tailsFall';
const ADV_DEFAULT = 'default', ADV_CUSTOM = 'custom';
const amiParametersColumns = [{
  key: "type",
  dataIndex: "type",
  title: "Type",
  width: "20%"
}, {
  key: "name",
  dataIndex: "name",
  title: "Name",
  width: "30%"
}, {
  key: "value",
  dataIndex: "value",
  title: "Value",
  width: "70%"
}];

const dcdTypeOptions = [{ key: 0, title: "No DCD" }, { key: 1, title: "Constant DCD" }, { key: 2, title: "Uncorrelated triangular DCD variation" }, { key: 3, title: "Uncorrelated sinusoidal DCD variation" }]
const periodicJitterOptions = [{ key: 0, title: "No periodic jitter" }, { key: 1, title: "Constant voltage shift" }, { key: 2, title: "Uncorrelated triangular voltage variation" }, { key: 3, title: "Uncorrelated sinusoidal voltage variation" }, { key: 4, title: "Constant time shift" }, { key: 5, title: "Uncorrelated triangular time variation" }, { key: 6, title: "Uncorrelated sinusoidal time variation" }]
const jittersColumns = [
  {
    key: "name",
    title: "Name",
    width: 140
  },
  {
    key: "type",
    title: "Type",
    width: 100
  },
  {
    key: "value",
    title: "Value"
  }
];
const amiJittersColumns = [
  {
    key: "name",
    title: "Name",
    width: 140
  },
  {
    key: "value",
    title: "Value"
  }
];

class ModelIbis extends PureComponent {
  constructor(props) {
    super(props);
    /**
     * props 
     *       // libType - SPCIE/IBIS, modelType - 'I/O,Input,Output,Tristate'
     * origin: { enableVoltage, fileName, modelName, modelType, name, libType } // origin - Can not be modified 
     * editModel : { enableVoltage, fileName, modelName, modelType, name, libType } // editModel - Editable
     * record: { component, deviceVcc, model, pinModels, net, pin, signal, usage,... }
     * type - tx/rx
     */
    const { editModel } = props;
    this.state = {
      files: [],
      modelList: [],
      modelTypeList: [],
      selectedModelList: [],
      multipleModelList: [],
      modelSelector: '',
      loading: true,
      modelNameInput: this.getData(editModel, 'modelName'),
      ibisFile: this.getData(editModel, 'fileName'),
      modelType: this.getData(editModel, 'modelType'),
      modelName: this.getData(editModel, 'modelName'),
      libraryId: this.getData(editModel, 'libraryId'),
      folder: this.getData(editModel, "folder"),
      version: this.getData(editModel, "version"),
      ODTValueValidateStatus: true,
      amiValidate: true,
      amiValidateMessage: "",
      advancedValidate: true,
      advancedValidateMessage: "",
      amiParamError: null,
      amiFile: null,
      updateAdvancedObj: {}
    };

    amiParametersColumns[0].render = (name, record) => {
      return {
        children: <span>{name}</span>,
        props: {
          rowSpan: record.groupLength
        }
      }
    };
    amiParametersColumns[1].render = (name, record) => {
      return <Tooltip
        classNames={{ root: 'aurora-tooltip' }}
        title={record.description ? `Description: ${record.description}` : null}
      >
        <span className="ami-parameters-title">{name}</span>
      </Tooltip>
    };
    amiParametersColumns[2].onCell = (record) => {
      if (record.disable && record.disable === true) {
        return {
          edit: false
        }
      }
      if (this.props.multipleModels) {
        if ([BOOLEAN, LIST, CORNER].includes(record.valueType)) {
          const options = record.valueType === CORNER
            ? record.valueList.map(item => { return { value: item.value, title: `${item.type}: ${item.value}` } })
            : record.valueList
          const { updateAdvancedObj } = this.state;
          const value = updateAdvancedObj && updateAdvancedObj.name === record.name && updateAdvancedObj.list ? [record.value, ...updateAdvancedObj.list] : [record.value]
          return {
            record: { ...record, value },
            edit: "select",
            selectMode: "multiple",
            options: options || [],
            dataIndex: "value",
            handleSave: (_record) => { this._editMultiParameterValue(_record, record, true, 'list') },
          }
        } else if ([RANGE].includes(record.valueType)) {
          return {
            record,
            edit: true,
            customInput: this.rangOption,
            dataIndex: "value",
          }
        }
      } else if ([BOOLEAN, LIST, CORNER].includes(record.valueType)) {
        const options = record.valueType === CORNER
          ? record.valueList.map(item => { return { value: item.value, title: `${item.type}: ${item.value}` } })
          : record.valueList
        return {
          record,
          edit: "select",
          options: options || [],
          dataIndex: "value",
          handleSave: (_record) => { this._editParameterValue(_record, true) },
        }
      }

      if ([GAUSSIAN, PARAMETER_DUAL_DIRAC, PARAMETER_DJRJ].includes(record.valueType)) {
        return {
          edit: false
        }
      }

      if (record.valueType !== CORNER) {
        return {
          record: { ...record, value: getTableAmiParametersValue(record) },
          edit: true,
          dataIndex: 'value',
          handleSave: (_record) => { this._editParameterValue(_record) }
        }
      }
    }

    amiParametersColumns[2].render = (name, record) => {
      if ([GAUSSIAN, PARAMETER_DUAL_DIRAC, PARAMETER_DJRJ].includes(record.valueType)) {
        return <span className="IC-ami-parameters-value"
          title={record.displayValue}
        >{record.displayValue}</span>
      } else if (this.props.multipleModels && [BOOLEAN, LIST, CORNER].includes(record.valueType)) {
        const { updateAdvancedObj } = this.state;
        const value = updateAdvancedObj && updateAdvancedObj.name === record.name && updateAdvancedObj.list ? [name, ...updateAdvancedObj.list].join(',') : name
        return <span className="IC-ami-parameters-value" title={value}>{value}</span>
      }
      return <span className="IC-ami-parameters-value" title={name}>{name}</span>
    }

  }

  getData(model, pram) {
    return model && [IBIS, IBIS_AMI].includes(model.libType) ? model[pram] : null;
  }

  getFileData = (isUpdate) => {
    const { ibisList, _compModel, editModel, product, libType, compAmiModel, displayFileType } = this.props;
    const { modelType, modelName, libraryId, ibisFile } = this.state;
    const files = ibisList ? JSON.parse(JSON.stringify(ibisList)) : [];
    const newState = { files };
    if (!ibisFile) {
      let fileName = "", _libraryId = "", version = null, folder = "", isAmi = false;
      if (compAmiModel && compAmiModel.fileName && libType === IBIS_AMI) {
        fileName = compAmiModel.fileName;
        _libraryId = compAmiModel.libraryId;
        folder = compAmiModel.folder;
        isAmi = true;
      } else if (_compModel && _compModel.fileName && _compModel.libType === libType && libType === IBIS) {
        fileName = _compModel.fileName;
        _libraryId = _compModel.libraryId;
        folder = _compModel.folder;
        version = _compModel.version;
        isAmi = _compModel.isAmi ? true : false;
        if (!version) {
          const findFile = folder ? ((files.find(it => it.type === "folder" && it.name === folder) || {}).children || []).find(it => it.id === _libraryId)
            : files.find(it => it.id === _libraryId) || {};
          version = findFile.version || "";
        }
      } else if (files.length) {
        if (product === SIERRA) {
          for (let _file of files) {
            if (_file.type !== 'folder') {
              fileName = _file.name;
              _libraryId = _file.id;
              version = _file.version;
              break;
            }
          }
        } else if (libType === IBIS_AMI || (libType === IBIS && product === ROCKY)) {
          for (let _file of files) {
            if (_file.children && _file.children.length) {
              const currentFile = _file.children[0];
              fileName = currentFile.name;
              _libraryId = currentFile.id;
              folder = _file.name;
              isAmi = currentFile.isAmi ? true : false;
              break;
            } else if (libType === IBIS && _file.type !== "folder") {
              fileName = _file.name;
              _libraryId = _file.id;
              isAmi = _file.isAmi ? true : false;
              break;
            }
          }
        } else {
          if (!_libraryId) {
            fileName = files[0].name;
            _libraryId = files[0].id;
            version = files[0].version;
          }
        }
      }
      newState.ibisFile = fileName;
      newState.libraryId = _libraryId;
      newState.folder = folder;
      newState.version = version;
      let modelObj = {
        libType: libType,
        fileName,
        libraryId: _libraryId,
        modelType: "",
        modelName: "",
        enableVoltage: '',
        version,
        folder,
      }
      if (displayFileType && product === ROCKY) {
        modelObj.isAmi = isAmi
      }
      this.props.saveChange(modelObj);
    } else {
      let findFile = null;
      if (editModel && editModel.folder) {
        const findFolder = files.find(item => item.name === editModel.folder);
        if (findFolder && findFolder.children) {
          findFile = findFolder.children.find(item => item.name === ibisFile);
        }
      } else {
        findFile = files.find(item => item.name === ibisFile);
      }
      if (findFile && findFile.id !== libraryId) {
        newState.libraryId = findFile.id;
        newState.version = findFile.version || newState.version;
        this.props.saveChange({
          ...editModel,
          libraryId: findFile.id,
          version: newState.version
        });
      }
    }
    this.setState(newState, () => {
      const { libraryId, ibisFile, folder } = this.state;
      if (libraryId && ibisFile) {
        this.getLibraryDetail(libraryId, "ROCKY", ibisFile, modelName, false, false);
        this.getIbisModels({ fileName: ibisFile, modelType, modelName, libraryId, folder });
        this.setState({
          multipleModelList: modelName ? [modelName] : []
        })
      } else {
        this.setState({
          loading: false,
        })
      }
    })
  }

  componentDidMount() {
    this.getFileData()
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.createStatus === true && this.props.createStatus === false) {
      this.props.closeModal()
    }
    if (prevState.libraryId !== this.state.libraryId) {
      this.clearMultipleModeList()
    }
    if (prevProps.libType !== this.props.libType) {
      const { editModel } = this.props;
      this.setState({
        modelNameInput: this.getData(editModel, 'modelName'),
        ibisFile: this.getData(editModel, 'fileName'),
        modelType: this.getData(editModel, 'modelType'),
        modelName: this.getData(editModel, 'modelName'),
        libraryId: this.getData(editModel, 'libraryId'),
        folder: this.getData(editModel, "folder"),
      }, () => {
        this.getFileData(true)
      })
    }
  }

  selectUnit = () => {
    return (
      <Select
        value={'V'}
        className='IC-select-model-input-after'
        popupClassName='IC-select-model-dropdown'
        popupMatchSelectWidth={false}
        getPopupContainer={trigger => trigger.parentNode}
        options={[{ value: "V", label: "V" }]}
      />
    )
  }

  rangOption = (props) => {
    const { record } = props;
    const { updateAdvancedObj } = this.state;
    const value = updateAdvancedObj && updateAdvancedObj.name === record.name ? updateAdvancedObj : null
    return <div>
      <span>range</span>
      <InputNumber
        value={value && value.min ? value.min : record.valueList[0] || 0}
        onChange={(e) => this.changeRange(e, record, "min")}
        className='range-input-number'
        size='small'
      // onKeyDown={(e) => this.axisRangeKeyDown(e, 'min')}
      // onBlur={() => this.axisChange('min')}
      />~
      <InputNumber
        value={value && value.max ? value.max : record.valueList[1] || 0}
        onChange={(e) => this.changeRange(e, record, "max")}
        className='range-input-number'
        size='small'
      // onKeyDown={(e) => this.axisRangeKeyDown(e, 'max')}
      // onBlur={() => this.axisChange('max')}
      />
      <span>step</span>
      <InputNumber
        value={value && value.step ? value.step : ""}
        onChange={(e) => this.changeRange(e, record, "step")}
        className='range-input-number'
        size='small'
      // onKeyDown={(e) => this.axisRangeKeyDown(e, 'step')}
      // onBlur={() => this.axisChange('step')}
      />
    </div>
  }

  changeRange = (value, record, type) => {
    const { updateAdvancedObj } = this.state;
    let _updateAdvancedObj = { ...updateAdvancedObj }
    if (updateAdvancedObj.name === record.name) {
      _updateAdvancedObj = {
        ..._updateAdvancedObj,
        [type]: value,
      }
    } else {
      _updateAdvancedObj = {
        min: record.valueList && record.valueList.length ? record.valueList[0] : 0,
        max: record.valueList && record.valueList.length > 1 ? record.valueList[1] : 0,
        parameterType: 'amiParameters',
        name: record.name,
        valueType: record.valueType,
        [type]: value,
      }
    }
    this.setState({
      updateAdvancedObj: _updateAdvancedObj,
    })
  }


  _editMultiParameterValue = (record, oldRecord) => {
    const { updateAdvancedObj } = this.state;
    let _updateAdvancedObj = { ...updateAdvancedObj }
    let newList = record.value;
    newList = record.value.filter(item => item !== oldRecord.value)

    if (updateAdvancedObj.name === record.name) {
      if (newList && !newList.length) {
        _updateAdvancedObj = {}
      } else {
        _updateAdvancedObj = {
          ..._updateAdvancedObj,
          list: newList,
        }
      }
    } else {
      _updateAdvancedObj = {
        parameterType: 'amiParameters',
        name: record.name,
        valueType: record.valueType,
        list: newList,
      }
    }
    this.setState({
      updateAdvancedObj: _updateAdvancedObj,
    })
  }

  rangOption = (props) => {
    const { record } = props;
    const { updateAdvancedObj } = this.state;
    const value = updateAdvancedObj && updateAdvancedObj.name === record.name ? updateAdvancedObj : null
    return <div>
      <span>range</span>
      <InputNumber
        value={value && value.min ? value.min : record.valueList[0] || 0}
        onChange={(e) => this.changeRange(e, record, "min")}
        className='range-input-number'
        size='small'
      // onKeyDown={(e) => this.axisRangeKeyDown(e, 'min')}
      // onBlur={() => this.axisChange('min')}
      />~
      <InputNumber
        value={value && value.max ? value.max : record.valueList[1] || 0}
        onChange={(e) => this.changeRange(e, record, "max")}
        className='range-input-number'
        size='small'
      // onKeyDown={(e) => this.axisRangeKeyDown(e, 'max')}
      // onBlur={() => this.axisChange('max')}
      />
      <span>step</span>
      <InputNumber
        value={value && value.step ? value.step : ""}
        onChange={(e) => this.changeRange(e, record, "step")}
        className='range-input-number'
        size='small'
      // onKeyDown={(e) => this.axisRangeKeyDown(e, 'step')}
      // onBlur={() => this.axisChange('step')}
      />
    </div>
  }

  changeRange = (value, record, type) => {
    const { updateAdvancedObj } = this.state;
    let _updateAdvancedObj = { ...updateAdvancedObj }
    if (updateAdvancedObj.name === record.name) {
      _updateAdvancedObj = {
        ..._updateAdvancedObj,
        [type]: value,
      }
    } else {
      _updateAdvancedObj = {
        min: record.valueList && record.valueList.length ? record.valueList[0] : 0,
        max: record.valueList && record.valueList.length > 1 ? record.valueList[1] : 0,
        parameterType: 'amiParameters',
        name: record.name,
        valueType: record.valueType,
        [type]: value,
      }
    }
    this.setState({
      updateAdvancedObj: _updateAdvancedObj,
    })
  }


  _editMultiParameterValue = (record, oldRecord) => {
    const { updateAdvancedObj } = this.state;
    let _updateAdvancedObj = { ...updateAdvancedObj }
    let newList = record.value;
    newList = record.value.filter(item => item !== oldRecord.value)

    if (updateAdvancedObj.name === record.name) {
      if (newList && !newList.length) {
        _updateAdvancedObj = {}
      } else {
        _updateAdvancedObj = {
          ..._updateAdvancedObj,
          list: newList,
        }
      }
    } else {
      _updateAdvancedObj = {
        parameterType: 'amiParameters',
        name: record.name,
        valueType: record.valueType,
        list: newList,
      }
    }
    this.setState({
      updateAdvancedObj: _updateAdvancedObj,
    })
  }

  onIbisFileChange = (value) => {
    const { files } = this.state;
    const { displayFileType } = this.props;
    let libraryId = '', name = value.name ? value.name : value, version = null, folder = "", isAmi = false;
    if (value.id) {
      libraryId = value.id;
      version = value.version;
      isAmi = value.isAmi;
    } else {
      const findId = files.find(file => file.fileName === value);
      if (findId) {
        libraryId = findId.id;
        version = findId.version;
        isAmi = findId.isAmi;
      }
    }

    const findIndex = files.findIndex(item => item.id === libraryId);
    if (findIndex > -1) {
      const isFolder = files[findIndex].type === "folder";
      folder = isFolder ? files[findIndex].name : "";
    }

    const model = { fileName: name, libraryId, modelType: "", modelName: "", enableVoltage: 0, folder };
    if (displayFileType) {
      model.isAmi = isAmi;
    }
    this.props.saveChange(version ? { ...model, version } : model);
    this.setState({
      ibisFile: name,
      loading: true,
      modelName: "",
      modelType: "",
      modelNameInput: '',
      libraryId,
      multipleModelList: [],
      folder: folder,
      version
    }, () => {
      this.getLibraryDetail(libraryId, "ROCKY", name, null, false, false);
      this.getIbisModels({ fileName: name, libraryId })
    })
  }

  getIbisModels({ fileName, modelType, modelName, libraryId }) {
    const { getIbisModel, type, libType, dataIndex } = this.props;
    const { files } = this.state;
    const findId = libraryId ? { id: libraryId } : files.find(item => item.name === fileName);
    const currentFile = files.find(item => item.id === libraryId)
    const _libType = libType === IBIS && currentFile && currentFile.type === "folder" && currentFile.fileType === "ibis_ami" ? IBIS_AMI : libType;
    if (findId) {
      getIbisModel(type, fileName, findId.id, _libType, dataIndex).then(models => {
        let modelList = this.getSortedList(models);
        let modelTypeList = this.getModelTypeList(models.models);
        let selectorList = this.getSelectorListList(models.selectorModels);
        let selectedModelList = [...modelList];
        let modelSelector = "";
        if (modelType || modelName) {
          if (modelName) {
            const find = modelList.find(item => item.name === modelName);
            if (find) {
              modelSelector = find.selector;
            }
          }
          selectedModelList = this.getSelectedModel({ modelList, modelType, modelSelector })
        }
        this.setState({
          modelList,
          selectedModelList,
          modelTypeList,
          selectorList,
          modelSelector,
          loading: false
        })
      }).catch(error => {
        this.setState({
          modelList: [],
          modelTypeList: [],
          selectorList: [],
          selectedModelList: [],
          modelSelector: "",
          loading: false
        })
      })
    } else {
      message.error(`Not found ${fileName} file.`);
      this.setState({
        loading: false
      })
    }
  }

  getSelectedModel = ({ modelList, modelType, modelSelector }) => {
    const { multipleModels } = this.props;
    let list = JSON.parse(JSON.stringify(modelList));
    if (multipleModels) {
      return list
    }
    if (modelType) {
      list = list.filter(item => item.type === modelType);
    }

    if (modelSelector) {
      list = list.filter(item => item.selector === modelSelector);
    }
    return list;
  }


  //Add a new modelType to the list
  addModelTypeList(model, oldList, key) {
    let list = [...oldList];
    let models = [];
    model.key = key;
    models.push(model);
    let modelType = model.type;

    let obj = {
      models,
      modelType
    };
    list.push(obj);
    return list;
  }

  //get selector list
  getSelectorListList = (selectorModels) => {
    let list = [];
    selectorModels.forEach((model, key) => {
      if (!list.includes(model.selector)) {
        list.push(model.selector);
      }
    })
    return list;
  }

  //get modelType list
  getModelTypeList(modelList) {
    let list = [];
    modelList.forEach((model, key) => {
      if (!list.includes(model.type)) {
        list.push(model.type);
      }
    })
    return list;
  }

  getSortedList(modelsObj) {
    let list = [];
    if (modelsObj && modelsObj.models) {
      const modelList = JSON.parse(JSON.stringify(modelsObj.models));
      const selectorModels = modelsObj.selectorModels ? JSON.parse(JSON.stringify(modelsObj.selectorModels)) : [];
      let selectorModelList = []
      for (let item of selectorModels) {
        if (item.models) {
          for (let model of item.models) {
            selectorModelList.push({ selector: item.selector, ...model });
          }
        }
      }
      for (let item of modelList) {
        const find = selectorModelList.find(model => model.name === item.name);
        if (find) {
          list.push({ ...find, ...item });
        } else {
          list.push({ ...item });
        }
      }
    }
    return list;
  }

  onSelectModelSelector = (key) => {
    const { modelList, modelType } = this.state;
    const prevType = this.state.modelSelector;
    if (prevType !== key) {
      const selectedModelList = this.getSelectedModel({ modelList, modelType, modelSelector: key });
      this.setState({
        modelSelector: key,
        modelName: "",
        selectedModelList
      })
    }
  }

  onAmiModelSelector = (e) => {
    const { modelNameInput, modelList } = this.state;
    this.props.onAmiModelSelector(e);
    if (e && e === AMI_OBJ_PARAM && modelList) {
      const model = modelList.find(item => item.name === modelNameInput);
      if (!model) return;
      const { name, description } = model;
      const haveODT = checkODT([name, description]);
      if (!haveODT) {
        this.props.onAmiModelUseSelector({ target: { value: CUSTOM_ODT } });
      }
    }
  }

  changeUpdateAdvancedObj = () => {
    const { multipleModelList, updateAdvancedObj } = this.state;
    const { amiModel, amiParameters, amiModelUse, amiODTValue, removeDcOffset, record } = this.props;
    const data = { amiModel, amiParameters, amiModelUse, amiODTValue, removeDcOffset }
    let diffKeyList = []
    // if (IBIS_AMI_LIST.includes(record.model.libType) && record.model.libraryId) {
    if ((record.model.libType === IBIS_AMI) && record.model.libraryId) {
      const obj = getAMIDiffData(data, record.amiParams, updateAdvancedObj);
      if (obj && obj.diffKeyList && obj.diffKeyList.length > 0) {
        diffKeyList = obj.diffKeyList
      }
    }
    return multipleModelList && multipleModelList.length > 1 ? ['model', ...diffKeyList] : diffKeyList
  }

  onAmiModelUseSelector = (e) => {
    const { amiValidate } = this.state;
    this.props.onAmiModelUseSelector(e);
    this.props.setValidate(true);
    if (!amiValidate) {
      this.props.changeODTValue({ target: { value: '50' } }, true);
      this.setState({
        amiValidate: true,
        amiValidateMessage: ""
      })
    }
  }

  onModelNameChange = (e, modelItem) => {
    const { modelList, libraryId, amiValidate, version } = this.state;
    const { libType, displayFileType, product } = this.props;
    if (modelList) {
      const model = modelList.find(item => item.name === modelItem.name);
      const { type, enable, deviceVcc, selector } = model;
      if (libType === IBIS_AMI || modelItem.isAmi === true) {
        const { name, description } = model;
        const haveODT = checkODT([name, description]);
        this.props.onAmiModelSelector(AMI_OBJ_PARAM);
        if (!haveODT) {
          this.props.onAmiModelUseSelector({ target: { value: CUSTOM_ODT } });
        } else {
          this.props.onAmiModelUseSelector({ target: { value: IBIS_ODT } });
        }
        if (!amiValidate) {
          this.props.changeODTValue({ target: { value: '50' } }, true);
          this.setState({
            amiValidate: true
          })
        }
        this.props.onRemoveDCOffsetChange({ target: { checked: true } });
        this.props.onChangeVrefVth(true);
      }
      const fileName = this.state.ibisFile;
      const selectedModelList = this.getSelectedModel({ modelList, modelType: type, modelSelector: selector });
      const _deviceVcc = deviceVcc && deviceVcc !== 'NA' ? parseFloat(deviceVcc).toString() : ""

      this.setState({
        modelName: modelItem.name,
        modelNameInput: modelItem.name,
        modelType: type,
        modelSelector: selector,
        selectedModelList
      })
      let modelObj = {
        libraryId,
        fileName,
        modelName: modelItem.name,
        modelType: type,
        enableVoltage: this.existEnableVoltage(type) ? (enable === 'NA' ? '1' : enable) : "",
        version,
      }
      if (displayFileType && product === ROCKY) {
        modelObj.isAmi = modelItem.isAmi
      }
      this.props.saveChange(modelObj,
        _deviceVcc);
      this.getLibraryDetail(libraryId, "ROCKY", fileName, modelItem.name, true, true);
      if (displayFileType && product === ROCKY) {
        this.props.updateAdsInfoFromModelType(libType, modelObj.isAmi);
      }
    }
  }

  modelNameInputChange = (e) => {
    this.setState({
      modelNameInput: e.target.value
    });
    const { modelList, modelType, modelSelector, libraryId, ibisFile, version } = this.state;
    const selectedModelList = this.getSelectedModel({ modelList, modelType, modelSelector });
    let value = e.target.value;
    let valueList = [];
    strDelimited(value).forEach(item => {
      if (item.match(/(\[)|(\])|(\\)|(\/)|(\()|(\))|(\|)|(\?)/)) {
        item = `\\${item}`;
      }
      valueList.push(item)
    })
    value = valueList.join("");
    let reg = new RegExp(`(${value})`, 'i');
    let list = [];
    selectedModelList.forEach(item => {
      if (item.info) {
        if (item.info.match(reg)) {
          list.push(item)
        }
      } else if (item.name && item.name.match(reg)) {
        list.push(item)
      }
    })

    this.setState({
      selectedModelList: list
    })
    const find = modelList.find(item => item.name === e.target.value);
    if (e.target.value && find) {
      const { type, enable, deviceVcc, selector } = find;
      const selectedModelList = this.getSelectedModel({ modelList, modelType: type, modelSelector: selector });
      let reg = new RegExp(`(${e.target.value})`, 'i');
      let list = [];
      selectedModelList.forEach(item => {
        if (item.info) {
          if (item.info.match(reg)) {
            list.push(item)
          }
        } else if (item.name && item.name.match(reg)) {
          list.push(item)
        }
      })
      const _deviceVcc = deviceVcc && deviceVcc !== 'NA' ? parseFloat(deviceVcc).toString() : ""
      this.setState({
        modelName: find.name,
        modelType: type,
        modelSelector: selector,
        selectedModelList: list
      });
      this.props.saveChange({
        libraryId,
        fileName: ibisFile,
        modelName: find.name,
        modelType: type,
        enableVoltage: this.existEnableVoltage(type) ? (enable === 'NA' ? '1' : enable) : "",
        version
      },
        _deviceVcc);
    }
  }

  blurModelNameInput = (e) => {
    this.setState({
      modelNameInput: e.target.value
    });
    const { modelList, modelType, libraryId, ibisFile, version } = this.state;

    const find = modelList.find(item => item.name === e.target.value);
    if (e.target.value && find) {
      const { type, enable, deviceVcc, selector } = find;
      const selectedModelList = this.getSelectedModel({ modelList, modelType: type, modelSelector: selector });
      this.setState({
        modelName: find.name,
        modelType: type,
        modelSelector: selector,
        selectedModelList
      });
      const _deviceVcc = deviceVcc && deviceVcc !== 'NA' ? parseFloat(deviceVcc).toString() : ""
      this.props.saveChange({
        libraryId,
        fileName: ibisFile,
        modelName: find.name,
        modelType: type,
        enableVoltage: this.existEnableVoltage(type) ? (enable === 'NA' ? '1' : enable) : "",
        version
      },
        _deviceVcc);
    } else if (!e.target.value) {
      this.props.saveChange({
        libraryId,
        fileName: ibisFile,
        modelName: "",
        modelType,
        version
      })
    }
  }

  existEnableVoltage(type) {
    const _type = type.toUpperCase();
    if (_type.includes('I/O') || _type.includes('IO') || _type === 'TRISTATE' || _type === '3-STATE' || _type === '3STATE') {
      return true;
    };
    return false;
  }

  getName = (name) => {
    if (this.modelNameListRef.current) {
      const width = this.modelNameListRef.current.clientWidth;
      if (name.length * 8 + 10 > width) {
        return <Tooltip placement="right" title={name}>{name}</Tooltip>
      } else {
        return name;
      }
    }
    return <Tooltip placement="right" title={name}>{name}</Tooltip>
  }

  onModelTypeChange = (key) => {
    const { libraryId, modelList, modelSelector, version } = this.state;
    const prevType = this.state.modelType;
    if (prevType !== key) {
      const selectedModelList = this.getSelectedModel({ modelList, modelType: key, modelSelector })
      this.props.saveChange({ modelType: key, modelName: "", enableVoltage: "", libraryId, version });
      this.setState({
        modelType: key,
        modelName: "",
        modelNameInput: "",
        selectedModelList
      })
    }
  }

  handleKeyDown = (e) => {
    e.target.blur();
  }

  cleanModelType = (e) => {
    e.stopPropagation();
    const { libraryId, modelList, modelSelector, version } = this.state;
    const selectedModelList = this.getSelectedModel({ modelList, modelType: "", modelSelector })
    this.props.saveChange({ modelType: "", modelName: "", enableVoltage: "", libraryId, version });
    this.setState({
      modelType: "",
      modelName: "",
      modelNameInput: '',
      selectedModelList
    })
  }

  cleanSelector = (e) => {
    e.stopPropagation();
    const { modelType, modelList } = this.state;
    const selectedModelList = this.getSelectedModel({ modelList, modelType, modelSelector: "" })
    this.setState({
      selectedModelList,
      modelSelector: ""
    })
  }

  cleanModelFile = (e) => {
    e.stopPropagation();
    this.props.saveChange({ fileName: "", libraryId: "", modelType: "", modelName: "", enableVoltage: 0, folder: "", version: "" });
    this.setState({
      ibisFile: "",
      modelName: "",
      modelType: "",
      libraryId: "",
      modelList: [],
      modelTypeList: [],
      selectorList: [],
      selectedModelList: [],
      modelSelector: "",
      modelNameInput: '',
      folder: "",
      version: ""
    })
  }

  changeFile = (files) => {
    let _files = [];
    for (let file of files) {
      const children = file && file.children ? file.children.map(item => {
        return {
          title: item.name,
          value: item.key,
          key: item.key
        }
      }) : []
      _files.push({
        title: file.name,
        value: file.key,
        key: file.key,
        children
      })
    }
    return _files
  }

  getSelectComponents = (ibisFile, libraryId, files, libType) => {
    const { product, displayFileType } = this.props;
    return libType === IBIS_AMI || (libType === IBIS && product === ROCKY) ?
      <TreeSelectComp
        value={{
          value: libraryId,
          label: ibisFile,
          key: libraryId,
        }
        }
        labelInValue
        onSelectItem={this.onIbisFileChange}
        size='small'
        showSearch
        popupClassName='IC-select-model-select-dropdown'
        className='IC-model-type-select'
        allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.cleanModelFile(e)} /> }}
        fileList={files}
        getPopupContainer={() => document.getElementById('root')}
        selected={libraryId && ibisFile ? `${libraryId}::${ibisFile}` : libraryId}
        displayFileType={displayFileType}
        popupMatchSelectWidth={false}
      />
      : product === SIERRA ? <TreeSelectComp
        value={ibisFile || undefined}
        onSelectItem={this.onIbisFileChange}
        size='small'
        showSearch
        popupClassName='IC-select-model-select-dropdown'
        className='IC-model-type-select'
        allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.cleanModelFile(e)} /> }}
        fileList={files}
        getPopupContainer={() => document.getElementById('root')}
        selected={libraryId}
      />
        : <Select
          value={ibisFile || undefined}
          onChange={this.onIbisFileChange}
          size='small'
          showSearch
          popupClassName='IC-select-model-select-dropdown'
          className='IC-model-type-select'
          allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.cleanModelFile(e)} /> }}
          getPopupContainer={() => document.getElementById('root')}
          options={files.map(file => ({ value: file.name, label: file.name, title: file.name }))}
        />
  }

  updateMultipleModeList = (e, value) => {
    const checked = e.target.checked
    let multipleModelList = this.state.multipleModelList
    if (checked) {
      multipleModelList.push(value)
    } else {
      multipleModelList = multipleModelList.filter(item => item !== value)
    }
    this.setState({
      multipleModelList: [...multipleModelList]
    })
  }

  getIsAmi = (amiFile, modelName) => {
    const modelList = amiFile.ibisAmi && amiFile.ibisAmi.models && amiFile.ibisAmi.models.length ? amiFile.ibisAmi.models : [];
    const findModel = modelList.find(it => it.name === modelName)
    if (findModel && findModel.algorithmicModels && findModel.algorithmicModels.length) {
      return true
    }
    return false
  }

  createExpsByModel = () => {
    const { multipleModelList, modelList, ibisFile, libraryId, version, amiFile } = this.state
    const { record, getPins, interfaceIndex, updateCreateStatus, multipleModels, applyAll, product, applyDriverAll, applyReceiverAll, powerOff, pu, pd } = this.props
    const { component, pin, usage, model: { modelName, libType, isAmi }, pinModels: recordPinModels } = record
    const baseModelName = multipleModels ? this.getBaseModel(this.props.record, libraryId) : null;

    const rowModelsList = modelList.filter(item => multipleModelList.includes(item.name) && baseModelName !== item.name)

    if (!ibisFile || !libraryId) {
      return;
    }

    let modelsList = rowModelsList.map(item => {
      if (modelName !== item.name) {
        let pinModels = getPins({ type: item.type, usage });

        for (let pinModel of recordPinModels) {
          const index = pinModels.findIndex(it => it.pinName === pinModel.pinName);

          if (pinModel.pinName === 'nd_pu' && index > -1) {
            pinModels[index].voltage = powerOff === "1" ? pu : parseFloat(item.deviceVcc).toString()
          }
          if (pinModel.pinName === 'nd_pd' && index > -1) {
            pinModels[index].voltage = powerOff === "1" ? pd : "0";
          }
          if (pinModel.pinName === 'nd_in' && index > -1) {
            pinModels[index].type = pinModel.type;
            pinModels[index].stimulus = pinModel.stimulus;
            if (pinModel.tabs) {
              pinModels[index].tabs = pinModel.tabs;
              pinModels[index].slew = pinModel.slew;
              pinModels[index].delay = pinModel.delay;
            }
          }

          if (pinModel.pinName === 'nd_en' && !OUTPUT.includes(item.modelType)) {
            //OUTPUT has no enable pin
            pinModels.push({ ...pinModel });
          }
        }

        let diffModelDiffInfo = {};
        if (product === ROCKY) {
          const isAmi = this.getIsAmi(amiFile, item.name)
          diffModelDiffInfo = this.getModelDiffInfo(isAmi ? IBIS_AMI : libType)
        }

        const newPinInfo = {
          deviceVcc: parseFloat(item.deviceVcc).toString(),
          pin,
          usage,
          pinModels: pinModels,
          model: {
            enableVoltage: this.existEnableVoltage(item.type) ? (item.enable === 'NA' ? '1' : item.enable) : "",
            modelName: item.name,
            fileName: ibisFile,
            libType: libType ? libType : IBIS,
            libraryId,
            modelType: item.type,
            version
          },
          powerOff,
          ...diffModelDiffInfo
        }
        // if (product === ROCKY) {
        //   delete newPinInfo.pinModels
        // }

        return {
          component,
          pinInfo: [{ ...newPinInfo }]
        }
      }

      else return null
    })

    if (product === ROCKY && !rowModelsList.length) {
      // sweep
      if (libType === IBIS_AMI || isAmi) {
        const { updateAdvancedObj } = this.state;
        const { amiModel, amiParameters, amiModelUse, amiODTValue, removeDcOffset } = this.props;
        const data = { amiModel, amiParameters, amiModelUse, amiODTValue, removeDcOffset }
        const { amiDiffData } = getAMIDiffData(data, record.amiParams, updateAdvancedObj)
        if (updateAdvancedObj && updateAdvancedObj.name) {
          let array = [];
          const findData = amiParameters.find(item => item.name === updateAdvancedObj.name);
          if (updateAdvancedObj.valueType === RANGE) {
            const { min, max, step } = updateAdvancedObj;
            const rangeMin = min ? min * 1 : 0, rangeMax = max ? max * 1 : 0;
            if (step) {
              array = generateRangeArray(rangeMin, rangeMax, step)
            }
          } else if ([LIST, BOOLEAN, CORNER].includes(updateAdvancedObj.valueType)) {
            const { list } = updateAdvancedObj;
            array = [...list]
          }
          if (array && array.length) {
            array.forEach(item => {
              modelsList.push({
                component,
                pinInfo: [{
                  pin,
                  usage,
                  amiModelInfo: { amiParameters: [{ ...findData, value: item }] }
                }]
              })
            })
          }
        } else if (amiDiffData && Object.keys(amiDiffData).length) {
          // amiDiffData
          modelsList = [{
            component,
            pinInfo: [{
              pin,
              usage,
              ...amiDiffData
            }]
          }]
        }
      } else if (libType === IBIS) {
        const { ifIbisAdvancedOpen, ibisAdvancedOptions, powerOff } = this.props;
        const data = { ifIbisAdvancedOpen, ibisAdvancedOptions }

        const { ibisDiffData } = getIBISDiffData(data, record);
        let diffData = { ...ibisDiffData }

        if ((powerOff && record.powerOff && powerOff !== record.powerOff)) {
          // power off difference
          diffData.powerOff = powerOff
        }
        if (diffData && Object.keys(diffData).length) {
          modelsList = [{
            component,
            pinInfo: [{
              pin,
              usage,
              ...diffData
            }]
          }]
        }
      }
    }

    this.props.createExpsByModel(modelsList, interfaceIndex, { applyDriverAll, applyReceiverAll, applyAll, record })
    modelsList.length && updateCreateStatus && updateCreateStatus(true)
    product === ROCKY && this.props.closeIbisPanel && this.props.closeIbisPanel()
  }

  getModelDiffInfo = (libType) => {
    // sweep
    const { updateAdvancedObj } = this.state;
    const { amiModel, amiParameters, amiModelUse, amiODTValue, removeDcOffset, record } = this.props;
    let diffInfo = {}
    if (libType === IBIS_AMI) {
      const data = { amiModel, amiParameters, amiModelUse, amiODTValue, removeDcOffset }
      const { amiDiffData } = getAMIDiffData(data, record.amiParams, updateAdvancedObj)
      // amiDiffData
      if (amiDiffData && Object.keys(amiDiffData).length) {
        diffInfo = { ...amiDiffData }
      }
    } else if (libType === IBIS) {
      const { ifIbisAdvancedOpen, ibisAdvancedOptions, powerOff } = this.props;
      const data = { ifIbisAdvancedOpen, ibisAdvancedOptions }
      const { ibisDiffData } = getIBISDiffData(data, record);
      let diffData = { ...ibisDiffData }
      if ((powerOff && record.powerOff && powerOff !== record.powerOff)) {
        // power off difference
        diffData.powerOff = powerOff
      }
      if (diffData && Object.keys(diffData).length) {
        diffInfo = { ...diffData }
      }
    }
    return diffInfo;
  }

  changeMultipleModeList = (type, list) => {
    this.setState({
      multipleModelList: [...list]
    })
  }

  clearMultipleModeList = () => {
    this.setState({
      multipleModelList: []
    })
  }

  getBaseModel = (record, libraryId) => {
    if (!record || !record.model) { return null }
    if (record.model.libraryId === libraryId) {
      return record.model.modelName;
    }
    return null
  }

  changeODTValue = (e) => {
    let validateStatus = this.amiValidateCheck(e, 'ODTValue');
    this.props.changeODTValue(e, validateStatus)
  }

  ODTBlur = (e, type) => {
    let validateStatus = this.amiValidateCheck(e, type);
    if (!validateStatus) {
      e.target.focus();
    }
  }

  changeIgnoreBits = (e) => {
    let validateStatus = this.amiValidateCheck(e, 'IgnoreBits');
    this.props.changeIgnoreBits(e, validateStatus)
  }

  //check the value of ODT and IgnoreBits
  amiValidateCheck = (e, type) => {
    const value = Number(e.target.value);
    switch (type) {
      case 'ODTValue':
        if (value >= 0 && Number.isInteger(value) && (e.target.value !== '') && value <= 251) {
          this.setState({
            amiValidate: true
          })
          return true;
        } else {
          this.setState({
            amiValidate: false,
            amiValidateMessage: "ODT value must be an integer between 0 and 251."
          })
          return false;
        }
      case 'IgnoreBits':
        if (value >= 0 && Number.isInteger(value) && (e.target.value !== '')) {
          this.setState({
            amiValidate: true
          })
          return true;
        } else {
          this.setState({
            amiValidate: false,
            amiValidateMessage: "Ignore bits must be an integer greater than or equal to 0."
          })
          return false;
        }
      default:
        break;
    }
  }

  selectAdvOption = (type, unit) => {
    return (<Select
      value={unit}
      onChange={(value) => this.editOptionsUnitChange(value, type)}
      className='IC-adv-option-input-after'
      popupClassName='IC-adv-option-input-after-dropdown'
      getPopupContainer={trigger => trigger.parentNode}
      options={[
        { value: 'ps', label: 'ps' },
        { value: 'ns', label: 'ns' },
        { value: 'us', label: 'us' },
        { value: 'ms', label: 'ms' },
        { value: 's', label: 's' }
      ]}
    />);
  }

  editOptionsUnitChange = (value, type) => {
    this.props.editOptionsUnitChange(value, type)
  }

  onAdvOptionDefaultChange = (e, type) => {
    const { ibisAdvancedOptions } = this.props;
    const value = ibisAdvancedOptions[type].value;
    if (e.target.value === ADV_DEFAULT) {
      const check = Number.isInteger(Number(value)) && value !== '' ? true : false;
      if (!check) {
        this.props.onAdvOptionValueChange({ target: { value: '0' } }, type)
      }
    }
    this.props.onAdvOptionDefaultChange(e, type)
  }

  modelParametersRender = (diffKeyList) => {
    const { amiParamError } = this.state;
    const { amiParameters } = this.props;
    const items = [
      {
        label: <div className="IC-ami-model-collapse-title">
          <span>AMI Parameters</span>
        </div>,
        key: "parameters",
        children: <Fragment>
          {amiParamError ? <span className='aurora-model-name-error-msg'>{amiParamError}</span> : null}
          <EditableTable
            rowKey={(record) => record.name}
            columns={amiParametersColumns}
            dataSource={this.getAmiParameters(amiParameters, diffKeyList) || []}
            size="small"
            className='IC-ami-parameters-table'
          />
        </Fragment>
      }
    ]
    return <div className='IC-select-dialog IC-select-dialog-ami-model clear'>
      <Collapse className='IC-ami-model-collapse' bordered={false} items={items} />
    </div>
  }

  getAmiParameters = (amiParameters, diffKeyList) => {
    const { type, multipleModels } = this.props;
    const { modelName, amiFile } = this.state;
    if (!amiParameters || !amiParameters.length || !modelName || !amiFile) return []
    const tableData = getTableAmiParameters(amiParameters, true, modelName, amiFile, type, multipleModels ? diffKeyList : []);
    return tableData;
  }

  //get library detail
  getLibraryDetail = async (libraryId, productType, fileName, modelName, apply, paramRemoveDcOffset) => {
    const { getIBISFolderFileDetail, type, amiParameters, removeDcOffset } = this.props;
    if (!libraryId || !getIBISFolderFileDetail) return;
    const fileList = await getIBISFolderFileDetail({ libraryId, productType });
    const amiFile = fileList.find(item => item.fileName === fileName);
    let ibisAmi = amiFile && amiFile.ibisAmi ? amiFile.ibisAmi : null;
    ibisAmi = ibisAMIModelParamsParse(ibisAmi);
    const _amiFile = {
      ...amiFile,
      ibisAmi
    }
    const model = ibisAmi && ibisAmi.models ? ibisAmi.models.find(item => item.name === modelName) : null;
    const modelInfo = model && model.algorithmicModels ? type ? model.algorithmicModels.find(item => item.parameterFile.toLowerCase().includes(type)) || model.algorithmicModels[0] : model.algorithmicModels[0] : {};
    const parameterFileName = modelInfo ? modelInfo.parameterFile : null;
    const parameterFile = ibisAmi && ibisAmi.amis ? ibisAmi.amis.find(item => item.name === parameterFileName) : null;
    const parameters = parameterFile && parameterFile.parameters ? parameterFile.parameters : null;
    const tableData = getTableAmiParameters(parameters, true, modelName, _amiFile, type);
    this.setState({
      amiFile: _amiFile
    })
    let _amiParameters = tableData.map(item => {
      return {
        name: item.name,
        value: item.value,
        sort: item.sort,
        type: item.type,
        defaultValue: item.Value,
      }
    })
    if (Object.keys(amiParameters).length === 0 || apply) {
      if (removeDcOffset || paramRemoveDcOffset) {
        _amiParameters = checkRemoveDcOffsetChange(_amiParameters, false)
      }
      this.props.saveAmiParameters(_amiParameters);
    } else {
      try {
        const originalDataMap = new Map(tableData.map(item => [item.name, item.Value]));
        let _originalAmiParameters = [...amiParameters];
        _originalAmiParameters.forEach(item => {
          if (originalDataMap.has(item.name)) {
            item.defaultValue = originalDataMap.get(item.name) || item.value;
          }
        })
        this.props.saveAmiParameters(_originalAmiParameters);
      } catch (error) {
        console.error(error)
      }
    }
  }

  _editParameterValue = (record, isSelection) => {
    const { amiParameters } = this.props;
    let _amiParameters = [...amiParameters];
    const { name } = record;
    const index = _amiParameters.findIndex(item => item.name === name);
    if (record.valueType === RANGE || (!isSelection && [INTEGER, FLOAT, TAP].includes(record.valueFormat))) {
      const error = amiParameterValueCheck(record.value, record.valueList, record.name, record);
      if (error) {
        this.updateAmiParamError(error)
        return;
      }
    }
    if (!isSelection && record.valueFormat === STRING) {
      //6.0 -> "6.0"
      record.value = `"${record.value}"`;
    }
    _amiParameters[index].value = record.value;
    this.props.saveAmiParameters(_amiParameters);
  }

  updateAmiParamError = (error) => {
    this.setState({
      amiParamError: error
    })
    setTimeout(() => {
      this.setState({
        amiParamError: null
      })
    }, 3000)
  }

  checkAllModel = (e) => {
    const checked = e.target.checked;
    const { multipleModelList, selectedModelList } = this.state;
    let _multipleModelList = [...multipleModelList];
    if (checked) {
      _multipleModelList = selectedModelList.map(item => item.name);
    } else {
      _multipleModelList = [];
    }
    this.setState({
      multipleModelList: _multipleModelList
    })
  }

  editSelectChange = (value, parentKey, key) => {
    //  this.props
    if (parentKey === "dutyCycle") {
      this.props.onChangeDutyDCycle(value, key)
    } else {
      this.props.onChangeJitter(value, key)
    }
  }

  onChangeData = (e, parentKey, key) => {
    const value = e.target.value
    if (parentKey === "dutyCycle") {
      this.props.onChangeDutyDCycle(value, key)
    } else {
      this.props.onChangeJitter(value, key)
    }
  }

  changeMultipleJitter = (value, list, parentKey, key) => {
    this.props.onChangeJitter(list, key)
  }

  changeJitterType = (e) => {
    const value = e.target.value;
    this.props.onChangeJitter(value, 'type')
  }

  onChangeJitterCheckout = (e, key, jitterTypes) => {
    const value = e.target.checked
    let typeList = JSON.parse(JSON.stringify(jitterTypes))
    if (value) {
      if (key === 'none') {
        typeList = ['none']
      } else {
        typeList = typeList.filter(item => item !== "none")
        typeList = [...new Set([...typeList, key])]
      }
    } else {
      typeList = typeList.filter(item => item !== key)
      if (!typeList.length) {
        typeList = ['none']
      }
    }
    this.props.onChangeJitter(typeList, 'types')
  }

  checkoutItem = (key, title, jitterTypes, isJitterDutyDisable) => {
    const disable = (key === "RJPP" && jitterTypes.includes("RJ")) || (key === "RJ" && jitterTypes.includes("RJPP")) || isJitterDutyDisable ? true : false
    return <Checkbox onChange={(e) => this.onChangeJitterCheckout(e, key, jitterTypes)} checked={jitterTypes.includes(key) ? true : false} disabled={disable}>{title}</Checkbox>
  }

  jitterContent = () => {
    const { jitter = {}, isJitterDutyDisable } = this.props;
    // disabled={isJitterDutyDisable}
    const types = jitter.types ? jitter.types : ['none'];
    const { RJPP, RJPP_BER, VNPP, VNPP_BER, RJ = [], RJ_MEAN = [], VN, PJ, PJ_TYPE, PJ_FREQ = '' } = jitter
    const unit = types.includes('PJ') && ![0].includes(PJ_TYPE) ? [4, 5, 6].includes(PJ_TYPE) ? "(s)" : "(V)" : ''

    return <Fragment>
      <div className='IC-select-dialog IC-select-dialog-ami-model clear' style={{ paddingLeft: 2 }}>
        <div className='IC-model-jitter-title'>Jitter</div>
        <div className='IC-model-jitter-radio-group'>
          {this.checkoutItem('none', 'None', types, isJitterDutyDisable)}
          {this.checkoutItem('RJPP', 'Peak-to-peak jitter with BER', types, isJitterDutyDisable)}
          {types.includes('RJPP') && <div className='IC-model-jitter-radio-option-item'>
            <div className='IC-model-jitter-item'>
              <span className='IC-model-jitter-title-item'>Jitter</span>
              <Input className='IC-model-jitter-input-item' size='small' value={RJPP} onChange={(value) => this.onChangeData(value, 'jitter', 'RJPP')} disabled={isJitterDutyDisable} />
            </div>
            <div className='IC-model-jitter-item'>
              <span className='IC-model-jitter-title-item'>BER</span>
              <Input className='IC-model-jitter-input-item' size='small' value={RJPP_BER} onChange={(value) => this.onChangeData(value, 'jitter', 'RJPP_BER')} disabled={isJitterDutyDisable} />
            </div>
          </div>}
          {this.checkoutItem('VNPP', 'Peak-to-peak jitter with voltage noise', types, isJitterDutyDisable)}
          {types.includes('VNPP') && <div className='IC-model-jitter-radio-option-item'>
            <div className='IC-model-jitter-item'>
              <span className='IC-model-jitter-title-item'>Jitter(V)</span>
              <Input className='IC-model-jitter-input-item' size='small' value={VNPP} onChange={(value) => this.onChangeData(value, 'jitter', 'VNPP')} disabled={isJitterDutyDisable} />
            </div>
            <div className='IC-model-jitter-item'>
              <span className='IC-model-jitter-title-item'>BER</span>
              <Input className='IC-model-jitter-input-item' size='small' value={VNPP_BER} onChange={(value) => this.onChangeData(value, 'jitter', 'VNPP_BER')} disabled={isJitterDutyDisable} />
            </div>
          </div>}
          {this.checkoutItem('RJ', 'Random Jitter', types, isJitterDutyDisable)}
          {types.includes('RJ') && <div className='IC-model-jitter-radio-option-item IC-model-jitter-radio-option-flex-item IC-model-jitter-rj-item'>
            <div className='IC-model-jitter-item IC-model-jitter-radio-option-flex-item'>
              <span className='IC-model-jitter-title-item'>Jitter</span>
              <TagsInput
                size='small'
                type={'RJ'}
                tagList={RJ}
                className="IC-model-jitter-tags-input-item"
                changeTagList={(e, value) => this.changeMultipleJitter(e, value, 'jitter', 'RJ')}
                displayInput={true}
                disabled={isJitterDutyDisable}
              />
            </div>
            <div className='IC-model-jitter-item IC-model-jitter-radio-option-flex-item'>
              <span className='IC-model-jitter-title-item'>Mean</span>
              <TagsInput
                size='small'
                type={'RJ_MEAN'}
                tagList={RJ_MEAN}
                className="IC-model-jitter-tags-input-item"
                changeTagList={(e, value) => this.changeMultipleJitter(e, value, 'jitter', 'RJ_MEAN')}
                displayInput={true}
                disabled={isJitterDutyDisable}
              />
            </div>
            <div className='IC-model-jitter-item IC-model-jitter-radio-option-flex-item'>
              <span className='IC-model-jitter-title-item'>Voltage Noise(V)</span>
              <Input className='IC-model-jitter-input-item' size='small' value={VN} onChange={(value) => this.onChangeData(value, 'jitter', 'VN')} disabled={isJitterDutyDisable} />
            </div>
          </div>}
          {this.checkoutItem('PJ', 'Periodic Jitter', types, isJitterDutyDisable)}
          {types.includes('PJ') && <div className='IC-model-jitter-radio-option-item IC-model-jitter-radio-option-flex-item IC-model-jitter-pj-item'>
            <div className='IC-model-jitter-item IC-model-jitter-radio-option-flex-item'>
              <span className='IC-model-jitter-title-item'>Jitter{unit}</span>
              <TagsInput
                size='small'
                type={'PJ'}
                tagList={PJ}
                className="IC-model-jitter-tags-input-item"
                changeTagList={(e, value) => this.changeMultipleJitter(e, value, 'jitter', 'PJ')}
                displayInput={true}
                disabled={isJitterDutyDisable}
              />
            </div>
            <div className='IC-model-jitter-item IC-model-jitter-radio-option-flex-item'>
              <span className='IC-model-jitter-title-item'>Type</span>
              <Select
                size='small'
                value={PJ_TYPE}
                onChange={(value) => this.editSelectChange(value, 'jitter', 'PJ_TYPE')}
                className='IC-model-jitter-select-item'
                popupClassName='IC-select-model-select-dropdown'
                getPopupContainer={() => document.getElementById('root')}
                options={periodicJitterOptions.map(item => ({
                  value: item.key,
                  label: item.title,
                }))}
                disabled={isJitterDutyDisable}
              />
            </div>
            <div className='IC-model-jitter-item IC-model-jitter-radio-option-flex-item'>
              <span className='IC-model-jitter-title-item'>Freq</span>
              <Input className='IC-model-jitter-input-item' size='small' value={PJ_FREQ} onChange={(value) => this.onChangeData(value, 'jitter', 'PJ_FREQ')} disabled={isJitterDutyDisable} />
            </div>
          </div>}

        </div>
      </div>
    </Fragment>
  }

  dutyCycleDistortionContent = () => {
    const { dutyCycle = {}, isJitterDutyDisable } = this.props;
    const { DCD, DCD_TYPE } = dutyCycle;
    return <Fragment>
      <div className='IC-select-dialog IC-select-dialog-ami-model clear' style={{ paddingLeft: 2 }}>
        <div className='IC-model-jitter-title'>Duty Cycle Distortion</div>
        <div className='IC-model-jitter-option'>
          <div className='IC-model-jitter-item'>
            <span className='IC-model-jitter-title-item'>Peak percentage</span>
            <Input className='IC-model-jitter-input-item' size='small' value={DCD} onChange={(value) => this.onChangeData(value, 'dutyCycle', 'DCD')} disabled={isJitterDutyDisable} />
          </div>
          <div className='IC-model-jitter-item'>
            <span className='IC-model-jitter-title-item'>Type</span>
            <Select
              size='small'
              value={DCD_TYPE}
              onChange={(value) => this.editSelectChange(value, 'dutyCycle', 'DCD_TYPE')}
              className='IC-model-jitter-select-item'
              popupClassName='IC-select-model-select-dropdown'
              getPopupContainer={() => document.getElementById('root')}
              options={dcdTypeOptions.map(item => ({
                value: item.key,
                label: item.title,
              }))}
              disabled={isJitterDutyDisable}
            />
          </div>
        </div>
      </div>

    </Fragment>
  }

  amiModelInstantiationContent = (key, diffKey) => {
    const { type, amiModel, amiModelUse, amiODTValue, multipleModels } = this.props;
    // const _amiModel = amiModel ? amiModel : (libType === IBIS_AMI ? (dataIndex === 'receiver' ? AMI_OBJ_PARAM : IBIS_AMI_FILE_MODEL) : '');
    const _amiModel = amiModel ? amiModel : AMI_OBJ_PARAM;
    const disabled = multipleModels ? getMultipleDisable(key, diffKey, this.state.multipleModelList) : false;
    const disabledClassName = disabled ? 'IC-select-dialog-ami-model-disabled' : null;
    return <Fragment>
      <div className={`IC-select-dialog IC-select-dialog-ami-model clear ${disabledClassName}`}>
        <div className='IC-select-model-title-item IC-select-ami-model-instantiation'>AMI Model Instantiation</div>
        <Select
          value={_amiModel}
          onChange={(e) => disabled ? null : this.onAmiModelSelector(e)}
          disabled={disabled}
          size='small'
          className='IC-model-type-select IC-ami-model-instantiation-select'
          popupMatchSelectWidth={false}
          popupClassName='IC-select-model-select-dropdown'
          getPopupContainer={() => document.getElementById('root')}
          options={[
            {
              value: IBIS_AMI_FILE_MODEL,
              label: 'IBIS_AMI_FILE / IBIS_AMI_MODEL'
            },
            {
              value: AMI_OBJ_PARAM,
              label: 'AMI_OBJ / AMI_PARAM'
            }
          ]}
        />
      </div>
      {_amiModel === AMI_OBJ_PARAM ? <div className={`IC-select-dialog IC-select-dialog-ami-model clear ${disabledClassName}`}>
        <RadioGroup onChange={(e) => disabled ? null : this.onAmiModelUseSelector(e)} value={amiModelUse} disabled={disabled}>
          <Radio key={IBIS_ODT} value={IBIS_ODT}>Use V/I table in .ibs</Radio>
          <Radio key={CUSTOM_ODT} value={CUSTOM_ODT}>
            Use custom {type === 'rx' ? 'ODT' : 'Rout'}
            <Input size='small' addonAfter="Ohm" value={amiODTValue} className='IC-select-model-input-odt'
              onChange={(e) => disabled ? null : this.changeODTValue(e)} disabled={amiModelUse !== CUSTOM_ODT}
              onBlur={(e) => disabled ? null : this.ODTBlur(e, 'ODTValue')} />
          </Radio>
        </RadioGroup>
      </div> : null}
    </Fragment>
  }

  removeDCoffsetContent = (key, diffKey) => {
    const { removeDcOffset, multipleModels } = this.props;
    const disabled = multipleModels ? getMultipleDisable(key, diffKey, this.state.multipleModelList) : false;
    const disabledClassName = disabled ? 'IC-select-dialog-ami-model-disabled' : null;
    return <div className={`IC-apply-dialog clear IC-remove-dc-offset  ${disabledClassName}`}>
      <Checkbox
        className=''
        checked={removeDcOffset}
        disabled={disabled}
        onChange={(e) => disabled ? null : this.props.onRemoveDCOffsetChange(e)}
      />
      <div className='IC-remove-dc-offset-span'>Automatically Remove DC Offset</div>
      <span className='IC-italic-span'>Note: You must set the voltage threshold to 0.</span>
    </div>
  }

  amiModelContent = (diffKeyList) => {
    const { modelName } = this.state;
    const { Config, amiParameters } = this.props;
    const simulate = Config && Config.simulate ? Config.simulate : "";
    return <Fragment>
      {simulate === HSPICE && this.amiModelInstantiationContent('amiModel', diffKeyList)}
      {simulate === HSPICE && this.removeDCoffsetContent('removeDcOffset', diffKeyList)}
      {modelName && amiParameters.length ? this.modelParametersRender(diffKeyList) : null}
    </Fragment>
  }

  modelJittersRender = (_model) => {
    const { bitRate, type, libType } = this.props;
    const columns = libType === IBIS ? jittersColumns : amiJittersColumns;
    return <JittersTable
      model={_model}
      type={libType}
      dirType={type}
      jitters={_model.jitters}
      bitRate={bitRate}
      jittersColumns={columns}
      saveModel={this.props.onChangeAdsInfo}
      updateError={this.updateError}
      tableClassName={'model-ibis-jitter-table'}
    />
  }

  updateError = (error) => {
    // to do
    // Error checking for jitter data
    // this.setState({
    //   error
    // })
  }

  adsModelContent = () => {
    const { adsInfo } = this.props;
    return <Fragment>
      {adsInfo.jitters && adsInfo.jitters.length ? this.modelJittersRender(adsInfo) : null}
    </Fragment>
  }

  getAmiSelectedModelList = (selectedModelList, fileName, amiFile) => {
    if (!amiFile || !amiFile.fileName) { return selectedModelList }
    if (fileName === amiFile.fileName) {
      const modelList = amiFile.ibisAmi && amiFile.ibisAmi.models && amiFile.ibisAmi.models.length ? amiFile.ibisAmi.models : [];
      const _selectedModelList = selectedModelList.map(item => {
        const findModel = modelList.find(it => it.name === item.name)
        if (findModel && findModel.algorithmicModels && findModel.algorithmicModels.length) {
          return { ...item, isAmi: true }
        }
        return item
      })
      return _selectedModelList
    }
    return selectedModelList
  }

  render() {
    const { ibisFile, files, selectedModelList, modelNameInput, modelSelector, selectorList, modelTypeList, modelType, loading, libraryId, multipleModelList, amiValidate, amiValidateMessage, modelList, amiFile } = this.state;
    const { type, pu, pd, applyAll, applySignal, applyAllMemory, clkMemory, product, powerOff, libType, multipleModels = false,
      createStatus = false, record, isMultiSetup, ifIbisAdvancedOpen, ibisAdvancedOptions, advancedValidate, advancedValidateMessage,
      isJitterDuty, isGroupExp, applyGroupAll, applyPCBAll, applyDriverAll, applyReceiverAll, Config, includePdn, includedDRAMPkgPower, displayFileType, editModel, applyTooltip, isBidirectional, applyUsageAll } = this.props;
    const { delayRise, delayFall, tailsRise, tailsFall } = ibisAdvancedOptions
    const text = product === ROCKY ? "Apply to all same-type pins" : "Apply the same model to all the pins in the component";
    const className = product === ROCKY ? "IC-apply-model-types-title" : "IC-apply-model-component-title";
    const baseModelName = multipleModels ? this.getBaseModel(record, libraryId, libType) : null;
    const allModels = selectedModelList.map(item => item.name).filter(item => item !== baseModelName);
    const checkedModels = [...new Set(multipleModelList.filter(item => item !== baseModelName))];
    const allChecked = checkedModels.length && allModels.length === checkedModels.length;
    const indeterminate = checkedModels.length && checkedModels.length < allModels.length;
    const liClassName = multipleModels ? "IC-model-select-allow-checked-li" : "";
    const diffKeyList = multipleModels ? this.changeUpdateAdvancedObj() : [];
    const modelDisable = multipleModels && diffKeyList && diffKeyList.length ? getMultipleDisable('model', diffKeyList) : false;

    const { simulate } = Config || {};
    const newModelList = displayFileType ? this.getAmiSelectedModelList(selectedModelList, ibisFile, amiFile) : [...selectedModelList];

    return (
      <Fragment>
        <div className={product === ROCKY ? 'IC-select-dialog clear' : 'IC-select-dialog IC-multi-spice-select-dialog clear'}>
          <div className='IC-select-model-title-item'>{product === ROCKY ? 'File' : 'Model File'}</div>
          {this.getSelectComponents(ibisFile, libraryId, files, libType)}
        </div>
        <Spin spinning={loading}>
          <div className='IC-select-dialog clear'>
            <div className='IC-select-model-title-item'>Model Type</div>
            <Select
              value={modelType || undefined}
              onChange={this.onModelTypeChange}
              size='small'
              showSearch
              className='IC-model-type-select'
              popupClassName='IC-select-model-select-dropdown'
              popupMatchSelectWidth={false}
              allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.cleanModelType(e)} /> }}
              getPopupContainer={() => document.getElementById('root')}
              options={(modelTypeList || []).map(item => ({
                value: item,
                label: item,
                title: item
              }))}
            />
          </div>
          <div className='IC-select-dialog clear'>
            <div className='IC-select-model-title-item'>Model Selector</div>
            <Select
              value={modelSelector || undefined}
              onChange={this.onSelectModelSelector}
              showSearch
              size='small'
              className='IC-model-type-select'
              popupMatchSelectWidth={false}
              allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.cleanSelector(e)} /> }}
              popupClassName='IC-select-model-select-dropdown'
              getPopupContainer={() => document.getElementById('root')}
              options={(selectorList || []).map(item => ({
                value: item,
                label: item,
                title: item
              }))}
            />
          </div>
          <div className='IC-apply-dialog clear' style={{ marginBottom: 6 }}>
            <div className='IC-model-title-item'>Model Name</div>
            {multipleModels ?
              <TagsInput
                className='IC-model-type-select'
                tagList={multipleModelList}
                changeTagList={this.changeMultipleModeList}
                disabled={modelDisable}
                customInput={<input type='text'
                  placeholder='Search...'
                  className='IC-model-search-input'
                  onChange={this.modelNameInputChange}
                  onBlur={(e) => this.blurModelNameInput(e)}
                  disabled={modelDisable}
                />}
              />
              :
              <Input
                size='small'
                onChange={this.modelNameInputChange}
                value={modelNameInput || ""}
                className='IC-select-model-name-input'
                onBlur={(e) => this.blurModelNameInput(e)}
              />}
          </div>
          <div className='IC-select-model-name-box clear'>
            <div className='IC-model-select-ul'>
              {multipleModels ? <span
                className={allChecked ? `IC-model-select-li IC-model-select-li-selected` : `IC-model-select-li`}
                key={"All"}
                title={"All Models"}
              >
                <label className='IC-model-label'>
                  <Checkbox
                    className='IC-model-checkbox-group'
                    onChange={(e) => this.checkAllModel(e)}
                    checked={allChecked}
                    indeterminate={indeterminate}
                    disabled={modelDisable}
                  >
                    All Models
                  </Checkbox>
                </label>
              </span> : null}
              {newModelList && newModelList.map(item => {
                const checked = multipleModels ? multipleModelList.includes(item.name) : item.name === modelNameInput
                const disabledClassName = modelDisable || (baseModelName && baseModelName === item.name) ? "IC-model-select-li-selected-disable" : false;
                return <span
                  className={checked ? `IC-model-select-li IC-model-select-li-selected ${disabledClassName} ${liClassName}` : `IC-model-select-li ${disabledClassName} ${liClassName}`}
                  key={item.name}
                  title={item.info}
                  onClick={!disabledClassName ? (e) => this.onModelNameChange(e, item) : null} >
                  {multipleModels ?
                    <label className='IC-model-label'>
                      <Checkbox
                        className='IC-model-checkbox'
                        checked={checked}
                        onChange={!disabledClassName ? (e) => this.updateMultipleModeList(e, item.name) : null}
                        disabled={disabledClassName ? true : false}
                      />
                      {/*  <input
                        type="checkbox"
                        className='IC-model-checkbox'
                        onClick={!disabledClassName ? (e) => this.updateMultipleModeList(e, item.name) : null}
                        readOnly
                        checked={checked}
                        disabled={disabledClassName ? true : false}
                      /> */}
                      <span>{item.name}</span>{item.description ? `,\xa0\xa0\xa0\xa0${item.description}` : ""}{disabledClassName ? " (Base)" : ""}
                      {displayFileType && item.isAmi ? <Tag color="green" className='ami-fileType-tag'>AMI</Tag> : null}
                    </label>
                    : <Fragment>
                      <span>{item.name}</span>{item.description ? `,\xa0\xa0\xa0\xa0${item.description}` : ""}
                      {displayFileType && item.isAmi ? <Tag color="green" className='ami-fileType-tag'>AMI</Tag> : null}
                    </Fragment>}
                </span>
              })}
            </div>
          </div>
          {product === ROCKY && simulate === ADS ? this.adsModelContent() : null}
          {((type === 'tx' && product !== ROCKY) || (product === ROCKY && simulate !== ADS && ((type === 'tx' && !includePdn) || (type === 'rx' && !includedDRAMPkgPower)))) && <Fragment>
            <div className='IC-select-power-dialog clear' style={{ paddingLeft: 2 }}>
              <div className='IC-model-title-item'>Power Off</div>
              <Switch
                size="small"
                className="IC-power-off-switch"
                checked={powerOff === '1'}
                onChange={(checked) => this.props.powerOffChange(checked, modelList)}
              />
            </div>
            {powerOff === "1" ? <Fragment> <div className='IC-select-power-dialog clear'>
              <div className='IC-model-title-item'>V_PU</div>
              <Input
                disabled={powerOff === '0'}
                size='small'
                onChange={(e) => { this.props.changeVoltage(e, 'pu') }}
                value={(powerOff === '1' && pu) || ""}
                className='IC-select-model-input'
                onPressEnter={e => this.handleKeyDown(e)}
                addonAfter={this.selectUnit()}
              />
            </div>
              <div className='IC-select-power-dialog clear'>
                <div className='IC-model-title-item'>V_PD</div>
                <Input
                  disabled={powerOff === '0'}
                  size='small'
                  onChange={(e) => { this.props.changeVoltage(e, 'pd') }}
                  value={(powerOff === '1' && pd) || ""}
                  className='IC-select-model-input'
                  onPressEnter={e => this.handleKeyDown(e)}
                  addonAfter={this.selectUnit()}
                />
              </div></Fragment> : null}
            {isJitterDuty ? <Fragment>
              {this.dutyCycleDistortionContent()}
              {this.jitterContent()}
            </Fragment> : null}
          </Fragment>}
        </Spin>
        {/* multipleModels是sweep中的base */}
        {product === ROCKY && (libType === IBIS_AMI || editModel.isAmi) ? multipleModels ? this.amiModelContent(diffKeyList) : this.amiModelContent() : null}

        {product === ROCKY && libType === IBIS && simulate === HSPICE &&
          <div className="IC-advanced-wrap">
            <div className="IC-select-dialog IC-model-select-advanced clear">
              <div className='IC-model-select-advanced-title'>Advanced Options</div>
              <Switch
                size="small"
                className="IC-advanced-off-switch"
                checked={ifIbisAdvancedOpen === '1'}
                onChange={this.props.advanceOffChange}
              />
            </div>
            {ifIbisAdvancedOpen === '1' ?
              <div className="IC-model-select-advanced-options clear">
                <div className='IC-model-select-advanced-item'>
                  <div className='IC-model-select-advanced-item-title'>Remove initial delay from Rising Waveform</div>
                  <RadioGroup onChange={(e) => this.onAdvOptionDefaultChange(e, DELAY_RISING)} value={delayRise && delayRise.isDefault ? ADV_DEFAULT : ADV_CUSTOM}>
                    <Radio value={ADV_DEFAULT}>Default</Radio>
                    <Radio value={ADV_CUSTOM}>
                    </Radio>
                    <Input size='small' value={delayRise && delayRise.value ? delayRise.value : ''}
                      onChange={(e) => this.props.onAdvOptionValueChange(e, DELAY_RISING)}
                      onBlur={(e) => this.props.advancedValueCheck()}
                      disabled={delayRise && delayRise.isDefault ? true : false}
                      className='IC-model-select-advanced-item-input'
                      addonAfter={this.selectAdvOption(DELAY_RISING, delayRise && delayRise.unit ? delayRise.unit : 'ps')} />
                  </RadioGroup>
                </div>
                <div className='IC-model-select-advanced-item'>
                  <div className='IC-model-select-advanced-item-title'> Remove initial delay from Falling Waveform</div>
                  <RadioGroup onChange={(e) => this.onAdvOptionDefaultChange(e, DELAY_FALLING)} value={delayFall && delayFall.isDefault ? ADV_DEFAULT : ADV_CUSTOM}>
                    <Radio value={ADV_DEFAULT}>Default</Radio>
                    <Radio value={ADV_CUSTOM}>
                    </Radio>
                    <Input size='small' value={delayFall && delayFall.value ? delayFall.value : ''}
                      onChange={(e) => this.props.onAdvOptionValueChange(e, DELAY_FALLING)}
                      onBlur={(e) => this.props.advancedValueCheck()}
                      disabled={delayFall && delayFall.isDefault ? true : false}
                      className='IC-model-select-advanced-item-input'
                      addonAfter={this.selectAdvOption(DELAY_FALLING, delayFall && delayFall.unit ? delayFall.unit : 'ps')} />
                  </RadioGroup>
                </div>
                <div className='IC-model-select-advanced-item'>
                  <div className='IC-model-select-advanced-item-title'>Remove flat tails from Rising Waveform</div>
                  <RadioGroup onChange={(e) => this.onAdvOptionDefaultChange(e, TAILS_RISING)} value={tailsRise && tailsRise.isDefault ? ADV_DEFAULT : ADV_CUSTOM}>
                    <Radio value={ADV_DEFAULT}>Default</Radio>
                    <Radio value={ADV_CUSTOM}>
                    </Radio>
                    <Input size='small' value={tailsRise && tailsRise.value ? tailsRise.value : ''}
                      onChange={(e) => this.props.onAdvOptionValueChange(e, TAILS_RISING)}
                      onBlur={(e) => this.props.advancedValueCheck()}
                      disabled={tailsRise && tailsRise.isDefault ? true : false}
                      className='IC-model-select-advanced-item-input'
                      addonAfter={this.selectAdvOption(TAILS_RISING, tailsRise && tailsRise.unit ? tailsRise.unit : 'ps')} />
                  </RadioGroup>
                </div>
                <div className='IC-model-select-advanced-item'>
                  <div className='IC-model-select-advanced-item-title'>Remove flat tails from Falling Waveform</div>
                  <RadioGroup onChange={(e) => this.onAdvOptionDefaultChange(e, TAILS_FALLING)} value={tailsFall && tailsFall.isDefault ? ADV_DEFAULT : ADV_CUSTOM}>
                    <Radio value={ADV_DEFAULT}>Default</Radio>
                    <Radio value={ADV_CUSTOM}>
                    </Radio>
                    <Input size='small' value={tailsFall && tailsFall.value ? tailsFall.value : ''}
                      onChange={(e) => this.props.onAdvOptionValueChange(e, TAILS_FALLING)}
                      onBlur={(e) => this.props.advancedValueCheck()}
                      disabled={tailsFall && tailsFall.isDefault ? true : false}
                      className='IC-model-select-advanced-item-input'
                      addonAfter={this.selectAdvOption(TAILS_FALLING, tailsFall && tailsFall.unit ? tailsFall.unit : 'ps')} />
                  </RadioGroup>
                </div>
              </div> : null}
          </div>}
        {/* {product === ROCKY && libType === IBIS_AMI && <div className='IC-select-dialog IC-select-dialog-ami-model IC-select-dialog-ami-ignore-bits clear'>
          Ignore Bits
          <Input size='small' value={amiIgnoreBits} className='IC-select-model-input-odt'
            onChange={(e) => this.changeIgnoreBits(e)} disabled={!amiIgnoreBitsStatus} />
          <Switch className='IC-select-dialog-ami-ignore-bits-switch' size="small" checked={amiIgnoreBitsStatus} onChange={this.changeIgnoreBitsStatus} />
        </div>
        } */}

        {product === SIERRA && libType === IBIS && !applyTooltip && <Fragment>
          {!isMultiSetup && !multipleModels ? <div className='IC-apply-dialog clear'>
            <div className={`IC-apply-model-title IC-apply-signal-title`}>Apply model to all the component pin in the same signal</div>
            <Checkbox
              className='IC-model-apply-checkbox'
              checked={applySignal}
              onChange={(e) => this.props.onApplySignalChange(e)}
            />
          </div> : null}
          {!multipleModels ? <div className='IC-apply-dialog clear'>
            <div className={`IC-apply-model-title ${className}`}>{text}</div>
            <Checkbox
              className='IC-model-apply-checkbox'
              checked={applyAll}
              onChange={(e) => this.props.onApplyChange(e)}
            />
          </div> : null}
          {isGroupExp && !multipleModels ?
            <div className='IC-apply-dialog clear'>
              <div className={`IC-apply-model-title IC-apply-pcb-title`}>Apply the same model to all the components pins of the same PCB</div>
              <Checkbox
                className='IC-model-apply-checkbox IC-model-apply-pcb-checkbox'
                checked={applyPCBAll}
                onChange={(e) => this.props.onApplyPCBChange(e)}
              />
            </div> : null}
          {isGroupExp && !multipleModels ?
            <div className='IC-apply-dialog clear'>
              <div className={`IC-apply-model-title IC-apply-pcb-title`}>Apply the same model to all the components pins of the same experiment</div>
              <Checkbox
                className='IC-model-apply-checkbox IC-model-apply-pcb-checkbox'
                checked={applyGroupAll}
                onChange={(e) => this.props.onApplyGroupChange(e)}
              />
            </div> : null}
          {isGroupExp && multipleModels ? <Fragment>
            <div className='IC-apply-dialog clear'>
              <div className={`IC-apply-model-title IC-apply-group-title`}>Apply the same model to all Drivers</div>
              <Checkbox
                className='IC-model-apply-checkbox'
                checked={applyDriverAll}
                onChange={(e) => this.props.onApplyUsageChange(e, "applyDriverAll")}
              />
            </div>
            <div className='IC-apply-dialog clear'>
              <div className={`IC-apply-model-title IC-apply-group-title`}>Apply the same model to all Receivers</div>
              <Checkbox
                className='IC-model-apply-checkbox'
                checked={applyReceiverAll}
                onChange={(e) => this.props.onApplyUsageChange(e, "applyReceiverAll")}
              />
            </div>
            {this.props.getCheckboxRender && this.props.getCheckboxRender()}
          </Fragment> : null}
          {isBidirectional && IO.includes(modelType) ? <div className='IC-apply-dialog clear'>
            <div className={`IC-apply-model-title IC-apply-pcb-title`}>Apply the same model to driver/receiver to same pin in the component</div>
            <Checkbox
              className='IC-model-apply-checkbox IC-model-apply-pcb-checkbox'
              checked={applyUsageAll}
              onChange={(e) => this.props.onApplyUsageChange(e, "applyUsageAll")}
            />
          </div> : null}
          {multipleModels ? <div className='rlc-sweep-create'>
            <Button type="primary" className='rlc-sweep-create-btn' loading={createStatus} onClick={() => this.createExpsByModel()}>Create</Button>
          </div> : null}
        </Fragment>}
        {product === ROCKY ? <Fragment>
          <div className='IC-apply-dialog clear'>
            <div className={`IC-apply-model-title ${className}`}>{text}</div>
            <Checkbox
              className='IC-model-apply-checkbox'
              checked={applyAll}
              onChange={(e) => this.props.onApplyChange(e)}
            />
          </div>
          {multipleModels && <div className='rlc-sweep-create'>
            <Button type="primary" className='rlc-sweep-create-btn' loading={createStatus} onClick={() => this.createExpsByModel()}>Create</Button>
          </div>}
        </Fragment> : null}
        {product === ROCKY && clkMemory && applyAll ? <div className='IC-apply-sub-dialog clear'>
          <span className='IC-sub-apply-box'></span>
          <div className='IC-apply-memory-model-title'>Apply to all same-type pins in components of the same part</div>
          <Checkbox
            className='IC-model-apply-checkbox'
            checked={applyAllMemory}
            onChange={(e) => this.props.onApplyMemoryChange(e)}
          />
        </div> : null}

        {product === ROCKY && (libType === IBIS_AMI || editModel.isAmi) && !amiValidate && <span className='odt-value-validate'>{amiValidateMessage}</span>}
        {product === ROCKY && libType === IBIS && !advancedValidate && <span className='odt-value-validate'>{advancedValidateMessage}</span>}

        {applyTooltip ? <Alert message={applyTooltip.msg} type="info" showIcon /> : null}
      </Fragment >
    );
  }
}

export default ModelIbis;